// this file is @generated

export interface EventTypeFromOpenApi {
  deprecated: boolean;
  description: string;
  featureFlag?: string | null;
  featureFlags?: string[] | null;
  /** The event type group's name */
  groupName?: string | null;
  /** The event type's name */
  name: string;
  schemas?: any | null;
}

export const EventTypeFromOpenApiSerializer = {
  _fromJsonObject(object: any): EventTypeFromOpenApi {
    return {
      deprecated: object["deprecated"],
      description: object["description"],
      featureFlag: object["featureFlag"],
      featureFlags: object["featureFlags"],
      groupName: object["groupName"],
      name: object["name"],
      schemas: object["schemas"],
    };
  },

  _toJsonObject(self: EventTypeFromOpenApi): any {
    return {
      deprecated: self.deprecated,
      description: self.description,
      featureFlag: self.featureFlag,
      featureFlags: self.featureFlags,
      groupName: self.groupName,
      name: self.name,
      schemas: self.schemas,
    };
  },
};
